var Work = (function($) {
  function initWorkAutoplay() {
    const videos = document.querySelectorAll(".work-item__video");

    if (!videos.length) return;
    // 👉 Marcar los 4 primeros como ya cargados (priority)
    const priorityVideos = document.querySelectorAll(
      ".js-work-item-video--priority"
    );

    priorityVideos.forEach(video => {
      video.dataset.loaded = "1";
    });

    function loadVideo(video) {
      if (video.dataset.loaded) return;

      video.querySelectorAll("source").forEach(source => {
        if (source.dataset.src && !source.src) {
          source.src = source.dataset.src;
        }
      });

      video.load();
      video.dataset.loaded = "1";
    }

    function applyStart(video) {
      const trim = video._trim;
      if (!trim || trim.startApplied || video.readyState < 1) return;

      if (trim.start > 0) {
        try {
          video.currentTime = trim.start;
        } catch (e) {}
      }

      trim.startApplied = true;
    }

    function playVideo(video) {
      loadVideo(video);

      const play = () => {
        applyStart(video);
        video.play().catch(() => {});
      };

      if (video.readyState >= 1) {
        play();
      } else {
        video.addEventListener("loadedmetadata", play, { once: true });
      }
    }

    videos.forEach(video => {
      const start = parseFloat(video.dataset.start || 0);
      const end = parseFloat(video.dataset.end || 0);

      video._trim = {
        start,
        end,
        startApplied: false
      };

      video.addEventListener("timeupdate", () => {
        const trim = video._trim;
        if (!trim) return;

        const { start, end } = trim;

        if (!end || end <= start) return;

        if (video.currentTime >= end) {
          try {
            video.currentTime = start;
            video.play().catch(() => {});
          } catch (e) {}
        }
      });
    });

    /**
     * 1) Preload antes de llegar al viewport
     */
    const preloadObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            preloadObserver.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "200px 0px",
        threshold: 0
      }
    );

    /**
     * 2) Play/pause cuando realmente está visible
     */
    const playObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const video = entry.target;

          if (entry.isIntersecting) {
            playVideo(video);
          } else {
            video.pause();
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: 0.25
      }
    );

    videos.forEach(video => {
      preloadObserver.observe(video);
      playObserver.observe(video);
    });
  }

  function initWorkReveal() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const items = gsap.utils.toArray(".work-item");

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.set(items, { opacity: 1, y: 0, clearProps: "transform" });
      return;
    }

    items.forEach(item => {
      const isLeftColumn =
        item.offsetLeft <= (item.parentElement?.offsetLeft || 0) + 5;

      gsap.to(item, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        delay: isLeftColumn ? 0 : 0.08,
        scrollTrigger: {
          trigger: item,
          start: "top 85%",
          toggleActions: "play none none none",
          once: true
        }
      });
    });
  }

  function init() {
    if (!$(".work").length) {
      return;
    }

    initWorkAutoplay();
    initWorkReveal();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Work.init);
